// extracted by mini-css-extract-plugin
module.exports = {"pageTitleShadow":"textinput-module--pageTitleShadow--1zGFZ"};